import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { StompSubscription } from '@stomp/stompjs';
import { UUID } from 'angular2-uuid';
import { interval, of, Subscription, throwError, timer } from 'rxjs';
import { mergeMap, retryWhen, switchMap, takeWhile } from 'rxjs/operators';
import { Literals } from 'src/app/literals';
import { ReportModel } from 'src/app/Models/report-model';
import { BaReviewService } from 'src/app/Services/ba-review.service';
import { CodeReviewService } from 'src/app/Services/code-review.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { ReportService } from 'src/app/Services/report.service';
import { RestService } from 'src/app/Services/rest.service';
import { SharedService } from 'src/app/Services/shared.service';
import { WebsocketService } from 'src/app/Services/websocket.service';

@Component({
  selector: 'ze-report-viewer-view',
  templateUrl: './report-viewer-view.component.html',
  styleUrls: ['./report-viewer-view.component.scss']
})
export class ReportViewerViewComponent implements OnInit {
  currentReport: ReportModel = null;
  reportToken: string = null;
  reportNotFound: boolean = false;
  codeReviewCreatedBy: string;
  currentUser: string = null;
  isCurrentUserBusniessAnalyst: boolean = false;

  @Output("onChangeReport") onChangeReportEmitter = new EventEmitter<any>();
  @Input("fromCodeReview") fromCodeReview: boolean = false;
  @Input("reviewId") reviewId: string = "";

  stepNumberOpened: number = 0;
  selectedStepInStatistic: number = 0;
  showDiv: boolean = false;
  public isDropdownVisible: boolean = false;
  public isDropdownDisabled: boolean = false;
  public objectKeys = Object.keys;
  selectedBrowser: string = 'Chrome';
  datasetAvailable: boolean = true;
  stepExecBrowserKeys: {} = {};
  stepSelected: boolean = false;
  stepBrowserSelected = '';
  stepIterationSelected = '';
  isBrowserIterationDataAvailable = false;

  iterationOptions: string[] = ['1'];
  selectedIteration: string = this.iterationOptions[0];
  public secondsCounter;
  public counterSubs: Subscription;
  public reports: ReportModel[];
  public filterList: Array<ReportModel>;
  public index: number = 0;
  public stepwiseReport: ReportModel = new ReportModel();
  public showVideo: Boolean;
  public currentPage = 0;
  public currentPagedb2 = 0;
  public size = 10;
  public showHTML: boolean = false;
  public showIFrame: boolean = false;
  public searchText: string = "";
  public viewtype = '';
  displayedContent: string = '';
  public activeContent: string = 'statistic';
  public activeBtn: string = 'exe';
  user: string = "";
  dropdownState = 'closed';
  recentContentType = '';
  video_url: any = null;
  videoNotFound: boolean = false;
  videoShareLink = "";
  currentLink: string = '';

  currentReportLoadFailed: boolean = false;
  intialConnectionSuccessful: boolean = false;
  private stompSelectedBrowserIterationSubscription: StompSubscription;

   // Properties for second video session
  video_url_2: any = null;
  videoNotFound2: boolean = false;
  updatingVideoUrl: boolean = false;
  updatingVideoUrl2: boolean = false;
  activeVideoSession: number = 1;

  constructor(private route: ActivatedRoute,
    private _sharedService: SharedService,
    private reportService: ReportService,
    private sanitizer: DomSanitizer,
    private notifyservice: NotifyService,    
    private restService: RestService,
    private websocketService: WebsocketService,
    private codeReviewService: CodeReviewService,
    private http: HttpClient,
    private baservice : BaReviewService
  ) {

  }

  ngOnDestroy() {
    if (this.stompSelectedBrowserIterationSubscription) {
      this.stompSelectedBrowserIterationSubscription.unsubscribe();
    }
    this.websocketService._disconnect();
  }

  ngOnInit() {
    this.websocketService._connect();
    this.websocketService.onConnection().pipe(
      switchMap(data => {
        if (data && this.intialConnectionSuccessful) {
          return timer(1000).pipe(switchMap(() => of(data))); // Delay for 1 second and then emit the data
        } else {
          return of(data); // Emit the data immediately
        }
      })
    )
    .subscribe(data => {
      if (data) {
        this.intialConnectionSuccessful = true;
        this.currentUser = this.parseJwt(JSON.parse(localStorage.getItem("currentUser")).token).sub;
        this.isCurrentUserBusniessAnalyst = false;
        this.baservice.isUserBA().subscribe((response)=> {
          this.isCurrentUserBusniessAnalyst = response;
        }, (error) => {
        })

        if (!this.fromCodeReview) {
          this.route.params.subscribe(params => {
            this.reportToken = params['token'];
            this.datasetAvailable = false;
            this.reportService.getReportByToken(this.reportToken).subscribe(report => {
              this.currentReport = JSON.parse(JSON.stringify(report.data));
              this.showContent("statistic");

              if (this.hasLiveStatus(this.currentReport.report_links) && this.objectKeys(this.currentReport.report_links.live_status[this.objectKeys(this.currentReport.report_links.live_status)[0]]).length > 1) {
                this.datasetAvailable = true;
              } else if (this.hasLiveStatus(this.currentReport.report_links) && this.objectKeys(this.currentReport.report_links.live_status[this.objectKeys(this.currentReport.report_links.live_status)[0]]).length == 1) {
                this.http.get(this.restService.apis.isDataSetAvailable.url + this.currentReport._id).subscribe(
                  (data: boolean) => {
                    this.datasetAvailable = data;
                  }
                );
              }
            },
            (error) => {
              this.reportNotFound = true;
            });
          });
        } else {
          this.codeReviewService.getReportByCodeReviewId(this.reviewId).subscribe(report => {
            if (report["operationStatus"] != Literals.ERROR) {
              this.currentReport = JSON.parse(JSON.stringify(report.data[0]));
              this.codeReviewCreatedBy = report.data[1];
              this.showContent("statistic");
      
              if (this.hasLiveStatus(this.currentReport.report_links) && this.objectKeys(this.currentReport.report_links.live_status[this.objectKeys(this.currentReport.report_links.live_status)[0]]).length > 1) {
                this.datasetAvailable = true;
              } else if (this.hasLiveStatus(this.currentReport.report_links) && this.objectKeys(this.currentReport.report_links.live_status[this.objectKeys(this.currentReport.report_links.live_status)[0]]).length == 1) {
                this.http.get(this.restService.apis.isDataSetAvailable.url + this.currentReport._id).subscribe(
                  (data: boolean) => {
                    this.datasetAvailable = data;
                  }
                );
              }
            } else {
              this.reportNotFound = true;
            }
          },
          (error) => {
            this.reportNotFound = true;
          });
        }
      }
    });
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }

  isCurrentUserCodeReview() {
    return this.currentUser != null && this.codeReviewCreatedBy != null && this.codeReviewCreatedBy != undefined && this.currentUser == this.codeReviewCreatedBy;
  }

  hasLiveStatus(object) {
    if (object) {
      if (object.live_status) {
        return true;
      }
    }
    return false;
  }

  hasVideoLink(object) {
    if (object) {
      if (object.video_links) {
        if (object.video_links.length)
          return true;
      }
      if (object.video_link) { return true }
      if (object.links && this.selectedBrowser && this.selectedIteration) {
        const iteration = object.links[this.selectedBrowser][this.selectedIteration];
        return iteration.video_links !== undefined && iteration.video_links !== null;
      }
    }
    return false;
  }

   // Method to check if second video link exists
  hasSecondVideo(): boolean {
    if (this.currentReport && this.currentReport.report_links && this.currentReport.report_links.links && this.selectedBrowser && this.selectedIteration) {
      const iteration = this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration];
      return iteration.video_links_2 !== undefined &&
        iteration.video_links_2 !== null &&
        iteration.video_links_2 !== '';
    }
    return false;
  }

   // Method to switch between video sessions
  switchVideoSession(sessionNumber: number) {
    this.activeVideoSession = sessionNumber;

    // Load video 2 when user switches to it
    if (sessionNumber === 2 && this.video_url_2 === null && this.hasSecondVideo()) {
      this.updateVideoUrl2(this.currentReport.hub_ip,
        this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration]
          .video_links_2.split("video/")[1].split(".mp4")[0]);
    }
  }

  checkStepwiseDataAndUpdate() {
    this.currentReportLoadFailed = false;
    if (this.currentReport.report_links.live_status == null || this.currentReport.report_links.live_status == undefined) {
      return;
    } else if (this.currentReport.report_links.live_status[this.selectedBrowser][this.selectedIteration]['structure'] != null || this.currentReport.report_links.live_status[this.selectedBrowser][this.selectedIteration]['structure'] != undefined) {
      this.isBrowserIterationDataAvailable = true;
    } else {
      this.getSelectedBrowserIterationData(this.currentReport._id, this.selectedBrowser, this.selectedIteration, this.currentReport.report_links.live_status[this.selectedBrowser][this.selectedIteration]['_id']);
    }
  }

  getSelectedBrowserIterationData(currentReportId, currentSelectedBrowser, currentSelectedIteration, browserIterationId) {
    if (this.stompSelectedBrowserIterationSubscription) {
        this.stompSelectedBrowserIterationSubscription.unsubscribe();
      }
      let uuid: string = UUID.UUID();
      let currentBrowserIterationId: string = browserIterationId["$oid"]?browserIterationId["$oid"]:browserIterationId;
      this.stompSelectedBrowserIterationSubscription = this.websocketService.stompClient.subscribe('/message/browserIteration/id/' + uuid + '/browserIterationId/' + currentBrowserIterationId, (message) => {
        if (!(JSON.parse(message.body).operationStatus === Literals.ERROR)) {
          if(this.currentReport._id === currentReportId) {
            this.currentReport.report_links.live_status[currentSelectedBrowser][currentSelectedIteration] = JSON.parse(message.body).data;
            this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
            this.isBrowserIterationDataAvailable = true;
          }
        } else {
          // error in loading Current Report
          // this.currentReport = null;
          this.currentReportLoadFailed = true;
        }
      });
      let dbName = Literals.db1;
      if (this.viewtype === Literals.ide) {
        dbName = Literals.db2;
      }
      let data = { browserIterationId: currentBrowserIterationId, execution: { dbName: dbName }, uuid: uuid };
  
      this.websocketService._sendBrowserIterationId(data);
    }

  downloadFile() {
    this.http.get(this.restService.apis.paramdownload.url + this.currentReport._id, {
      responseType: 'blob'
    }).subscribe(data => {
      const blob = new Blob([data], { type: 'application/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'dataset' + '.csv';
      document.body.appendChild(a);
      a.click();
      // window.URL.revokeObjectURL(url);


    },error => {
      if (error.status === 404) {
        this.notifyservice.notify(Literals.error, Literals.Error, Literals.dataSetDoesNotExists)
      } else {
        this.notifyservice.notify(Literals.error, Literals.Error, Literals.errorInDownloadingDataset)
      }
    }
  );
  }

  downloadLog() {
    this.http.get(this.restService.apis.logFileDownload.url + this.currentReport._id, { responseType: 'text' }).subscribe((data) => {
      window.open(data.toString(), Literals.blank);
    }, error => {
      if(error.status === 404) {
        this.notifyservice.notify(Literals.error, Literals.Error, Literals.logDoesNotExists)
      } else {
        this.notifyservice.notify(Literals.error, Literals.Error, Literals.errorInDownloadingLogs)
      }      
    }
    );
  }

  onChangeBrowser(valueOfBrowsers) {
    this.video_url = null;
    this.video_url_2 = null;
    this.videoNotFound = false;
    this.videoNotFound2 = false;
    this.updatingVideoUrl = false;
    this.updatingVideoUrl2 = false;
    this.selectedBrowser = valueOfBrowsers.target.value;
    if(this.displayedContent === Literals.STEPEXECUTION) {
      this.isBrowserIterationDataAvailable = false;
      if (this.currentReport.run_status_text !== Literals.EXECUTE_FRAMEWORK) {
        if(this.stepSelected) {
          this.stepSelected = false;
          this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
        }
        this.iterationOptions = this.objectKeys(this.currentReport.report_links.live_status[this.selectedBrowser]);
      }     
    } else {
      if(this.stepSelected) {
        this.stepSelected = false;
        this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
      }
      this.iterationOptions = this.objectKeys(this.currentReport.report_links.links[this.selectedBrowser]);
    }
    this.selectedIteration = this.iterationOptions[0];
    this.checkStepwiseDataAndUpdate();
    this.stepNumberOpened = 1;
    if(this.displayedContent === 'video') {
      this.updateVideoUrl(this.currentReport.hub_ip, this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration].video_links.split("video/")[1].split(".mp4")[0]);
      // Update secondary video if exists
      if (this.hasSecondVideo()) {
        this.updateVideoUrl2(this.currentReport.hub_ip, this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration].video_links_2.split("video/")[1].split(".mp4")[0]);
      }
    }
  }

  onChangeIteration(valueOfIteration) {
    this.isBrowserIterationDataAvailable = false;
    this.checkStepwiseDataAndUpdate();
    this.video_url = null;
    this.video_url_2 = null;
    this.videoNotFound = false;
    this.videoNotFound2 = false;
    this.updatingVideoUrl = false;
    this.updatingVideoUrl2 = false;
    if(this.stepSelected) {
      this.stepSelected = false;
      this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
    }
    this.stepIterationSelected = valueOfIteration.target.value;
    this.stepNumberOpened = 1;
    if(this.displayedContent === 'video') {
      this.updateVideoUrl(this.currentReport.hub_ip, this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration].video_links.split("video/")[1].split(".mp4")[0]);
          // Update secondary video if exists
      if (this.hasSecondVideo()) {
        this.updateVideoUrl2(this.currentReport.hub_ip, this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration].video_links_2.split("video/")[1].split(".mp4")[0]);
      }
    }
  }

  updateVideoUrl(hubIp: string, filename: string) {
    this.updatingVideoUrl = true;
    let retryCount = 0;
    this.reportService.getVideoContent(hubIp, filename).pipe(
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error: any) => {
            if (error.status === 404 && retryCount < 9) {
              retryCount++;
              return interval(5000).pipe(takeWhile(() => retryCount <= 9));
            } else {
              return throwError(error);
            }
          })
        )
      )
    ).subscribe(
      (videoBlob: Blob) => {
        const videoUrl = URL.createObjectURL(videoBlob);
        this.video_url = videoUrl;
        this.updatingVideoUrl = false;
      },
      (error) => {
        if (error.status === 404) {
          this.videoNotFound = true;
        }
        this.updatingVideoUrl = false;
      }
    );
  }


  showContent(content: string) {
    this.activeContent = content;
    this.displayedContent = content;
    if(this.recentContentType !== content) {
      this.stepSelected = false;
      this.stepwiseReport = new ReportModel();
    }
    this.recentContentType = content;
    this.isDropdownVisible = false;
    this.isDropdownDisabled = false;
    if (content === Literals.video) {
      this.video_url = null;
      this.video_url_2 = null;
      this.videoNotFound = false;
      this.videoNotFound2 = false;
      this.updatingVideoUrl = false;
      this.updatingVideoUrl2 = false;
      this.activeVideoSession = 1;
      this.isDropdownVisible = true;
      this.isDropdownDisabled = false;
    } else if (content === Literals.STEPEXECUTION) {
      this.isDropdownVisible = true;
      this.isDropdownDisabled = false;
    }

    if (content=== Literals.video && this.currentReport.report_links.links){
      this.selectedBrowser = this.objectKeys(this.currentReport.report_links.links).pop();
      this.selectedIteration = this.objectKeys(this.currentReport.report_links.links[this.selectedBrowser]).pop();
      this.iterationOptions = this.objectKeys(this.currentReport.report_links.links[this.selectedBrowser]);
      this.updateVideoUrl(this.currentReport.hub_ip, this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration].video_links.split("video/")[1].split(".mp4")[0]);
    } else if (content=== Literals.STEPEXECUTION && this.currentReport.report_links.live_status){
      this.isBrowserIterationDataAvailable = false;
      if (this.currentReport.run_status_text === Literals.Completed || this.currentReport.run_status_text === Literals.Failed || this.currentReport.run_status_text === Literals.executionFailed) {
        if(!this.stepSelected) {
          this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
          this.stepBrowserSelected = '';
          this.stepIterationSelected = '';
          this.stepNumberOpened = 1;
          if(this.selectedStepInStatistic === 0) {
            this.selectedBrowser = this.objectKeys(this.currentReport.report_links.live_status).pop();
            this.selectedIteration =this.objectKeys(this.currentReport.report_links.live_status[this.selectedBrowser]).pop();
          } else {
            this.stepNumberOpened = this.selectedStepInStatistic;
            this.selectedStepInStatistic = 0;
          }
        }
        this.isDropdownDisabled = false;
      }

      if(this.selectedBrowser !== "" && this.selectedIteration !== "") {
        this.iterationOptions = this.objectKeys(this.currentReport.report_links.live_status[this.selectedBrowser]);
        this.isDropdownVisible = true;
      } else {
        this.iterationOptions = [];
        this.isDropdownVisible = false;
      }
      this.checkStepwiseDataAndUpdate();
    } else {
      this.iterationOptions = [];
    }
  }

  onChangeToStepwise(eventData: any): void {
    this.selectedBrowser = eventData[0];
    this.selectedIteration = eventData[1];
    this.selectedStepInStatistic = eventData[2];
    this.showContent('stepexecution');
  }

  openShareUrlPopup() {
    // Determine which video link to share based on active video session
    const iteration = this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration];
    let videoLink: string;

    if (this.activeVideoSession === 2 && this.hasSecondVideo()) {
      // Share second video link
      videoLink = iteration.video_links_2.split("video/")[1].split(".mp4")[0];
    } else {
      // Share first video link (default)
      videoLink = iteration.video_links.split("video/")[1].split(".mp4")[0];
    }

    this.onShareVideoUrl('dev', videoLink);
  }

  onShareVideoUrl(hubIp: string, filename: string) {
    this.videoShareLink = "";
    this.reportService.getVideoShareUrl(hubIp, filename).subscribe((url: string) => {
      this.videoShareLink = window.location.origin + "/video-viewer/" + url;
      this._sharedService.openOverlayshareTextEvent.emit([true, this.videoShareLink, undefined, hubIp, filename]);
    },
    (error) => {
      this.notifyservice.notify(Literals.error, Literals.Error, Literals.errorInGeneratingUrl);
    });
  }

  onChangeReport() {
    this.onChangeReportEmitter.emit(this.currentReport);
  }

   updateVideoUrl2(hubIp: string, filename: string) {
    this.updatingVideoUrl2 = true;
    let retryCount = 0;
    this.reportService.getVideoContent(hubIp, filename).pipe(
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error: any) => {
            if (error.status === 404 && retryCount < 9) {
              retryCount++;
              return interval(5000).pipe(takeWhile(() => retryCount <= 9));
            } else {
              return throwError(error);
            }
          })
        )
      )
    ).subscribe(
      (videoBlob: Blob) => {
        const videoUrl = URL.createObjectURL(videoBlob);
        this.video_url_2 = videoUrl;
        this.updatingVideoUrl2 = false;
      },
      (error) => {
        if (error.status === 404) {
          this.videoNotFound2 = true;
        }
        this.updatingVideoUrl2 = false;
      }
    );
  }
}
